import React from 'react';
import PropTypes from 'prop-types';

export function makeConcealable(WrappedComponent) {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.refToWrappedComponent = React.createRef();
    }

    displayName = `Concealable(${
      WrappedComponent.displayName || WrappedComponent.name || 'Component'
    })`;

    static defaultProps = {
      scrollOnShow: false,
    };

    static propTypes = {
      show: PropTypes.bool.isRequired,
      scrollOnShow: PropTypes.bool,
    };

    scrollToComponent = () => {
      this.refToWrappedComponent.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start', //'end'
      });
    };

    componentDidUpdate(prevProps) {
      if (this.props.scrollOnShow && !prevProps.show && this.props.show)
        this.scrollToComponent();
    }

    render() {
      const { show, scrollOnShow, ...passThroughProps } = this.props;
      return show ? (
        <div ref={this.refToWrappedComponent} className="concealable-wrapper">
          <WrappedComponent {...passThroughProps} />
        </div>
      ) : null;
    }
  };
}
